<template>
  <div>
    <h1 class="text-center">
      {{ is_blockly ? "Blockly " : "Coding " }} Questions
    </h1>
    <router-link
      class="btn-primary bg-green border-none leading-snug mb-2 inline-block px-4 py-2 text-white hover:bg-green-900 rounded-full no-underline"
      :to="`/${this.is_blockly ? 'blockly' : 'coding'}-add/`"
    >
      Add {{ is_blockly ? "Blockly " : "Coding " }} Question
    </router-link>
    <div />
    <Table :endpoint="endpoint" :tableConfig="tableConfig" />
  </div>
</template>

<script>
import siteConfig from "@/utils/siteConfig"
import Table from "@/components/DataTable/Table"

export default {
  components: { Table },
  props: ["is_blockly"],
  data() {
    return {
      siteURL: siteConfig.siteURL,
    }
  },
  computed: {
    tableConfig() {
      const list = [
        {
          header: { textContent: "Name", sortingParam: "name" },
          path: "name",
          classList: "w-1/3",
        },
        {
          header: { textContent: "Id" },
          path: "id",
        },
        {
          header: { textContent: "Created On", sortingParam: "created_on" },
          type: "date",
          path: "created_on",
        },
        {
          header: { textContent: "Updated On", sortingParam: "updated_on" },
          type: "date",
          path: "updated_on",
        },
        {
          header: { textContent: "No. of<br/>Sub Cases" },
          path: "submission_cases",
          formatter: function getSubmissionCasesCount(submission_cases) {
            const cases = JSON.parse(submission_cases) || []
            if (cases === undefined) {
              return 0
            }
            return cases.length || 0
          },
        },
        {
          header: { textContent: "Option" },
          routePath: "",
          type: "action",
          actionButtonText: "Edit",
          path: "id",
        },
      ]
      const actionCellIndex = list.findIndex(cell => cell.type === "action")
      list[actionCellIndex].routePath = `${
        this.is_blockly ? "/blockly" : "/code"
      }/:id`
      return list
    },
    endpoint() {
      return `${siteConfig.siteURL}admin/questions?search_by_type=${
        this.is_blockly ? 8 : 6
      }&fields=id,name,points,submission_cases,created_on,updated_on`
    },
  },
}
</script>
